import { currencyMXN } from "helpers/numbers";
import { handleOrderStatus } from "helpers/texts";
import { IOrder } from "interfaces/IOrder";
import { useNavigate } from "react-router-dom";

/**
 * custom props for the orders table content
 */
interface Props {
    /**
     * The orders object information
     */
    orders: IOrder[];
}

/**
 * The orders table content
 */
export const TableContent = ({ orders }: Props) => {
    const navigate = useNavigate();
    /**
     * handles the back button click and returns to the previous route
    */
    const onRowClick = (order: IOrder) => navigate("/inventories/orders/details", { state: order });

    return (
        <tbody>
            {orders.map((order) => (
                <tr key={`order ${order.id}`} onClick={() => onRowClick(order)} style={{ cursor: "pointer" }} >
                    <td className="text-center" >
                        {order.id}
                    </td>
                    <td className="text-center" >
                        {order.user_email}
                    </td>
                    <td className="text-center" >
                        {new Date(order.created_at).toLocaleString()}
                    </td>
                    <td className="text-center" >
                        {currencyMXN(order.total)}
                    </td>
                    <td className="text-center" style={{ minWidth: '140px' }} >
                        <span
                            className={`status-badge ${handleOrderStatus(order?.status)}`}
                        >
                            {handleOrderStatus(order?.status).replace("-", " ")}
                        </span>
                    </td>
                </tr>
            ))
            }
        </tbody>
    )
}
